module.exports = __webpack_public_path__ + "static/media/Anavadya.860b9b2f.jpg";